// extracted by mini-css-extract-plugin
module.exports = {"info":"Filters_info__1n7yx","group":"Filters_group__1lamQ","checkbox":"Filters_checkbox__1BJgv","btns":"Filters_btns__1aMBO","button":"Filters_button__3SiR4"};